import React, { Component } from 'react'
import {connect} from 'react-redux'
import {Switch, Route, withRouter} from 'react-router-dom'
import {Card} from '@myxplor/ui'
import Registration from '../registration'
import Details from '../gov-care-registration-details'
import AuthPersonnel from '../auth-personnel'
import Nav from './nav'

export class Onboarding extends Component {
  render() {
    const {
      base_url,
      gov_care_registration
    } = this.props

    return (
      <Card title="Onboarding">
        <Nav base_url={base_url} />
        {gov_care_registration.valid ? this.registered() : this.register()}
      </Card>
    )
  }

  register() {
    const {
      gov_care_registration,
      record_type,
      id
    } = this.props

    return (
      <Registration 
        gov_care_registration={gov_care_registration}
        record_type={record_type}
        id={id}
      />
    )
  }

  registered() {
    const {
      gov_care_registration, base_url
    } = this.props

    return (
      <Switch>
        <Route path={base_url + '/nominate'} component={AuthPersonnel} />
        <Route render={() => 
          <Details
            gov_care_registration={gov_care_registration}
          />} />
      </Switch>
    )
  }
}

const mapStateToProps = (state) => ({
  gov_care_registration: state.gov_care_registration
})

export default withRouter(connect(mapStateToProps)(Onboarding))


// WEBPACK FOOTER //
// ./src/onboarding/container.js